import { Button as AntButton, ButtonProps } from 'antd'
import React from 'react'

import { ButtonContainer } from './styles'

const buttonStyle = {
  width: '100%',
}

export interface CustomButtonProps extends ButtonProps {
  buttonHeight?: string // available options: 'low' and 'height'
  label: string
  bold?: boolean
  onClick?: () => void
}

const Button = ({ buttonHeight = 'high', label, bold, onClick, ...rest }: CustomButtonProps) => {
  return (
    <ButtonContainer id="nova-shared-Button-root">
      <AntButton
        id="nova-shared-Button-button"
        style={buttonStyle}
        className={[buttonHeight, bold && 'bold'].join(' ')}
        onClick={onClick}
        {...rest}
      >
        {label}
      </AntButton>
    </ButtonContainer>
  )
}

export default Button
